import KEYS from '../values/keys';
import { Dictionary } from 'vue-router/types/router';

class ToolService {

  setParamsToUrl(urlIn = '', params = []) {

    let currentParams = this.getUrlParams(urlIn);
    let currentParamsList = Object.keys(currentParams);
    let url = urlIn.split('?')[0];
    let symbol = '?';

    currentParamsList.forEach((p) => {
      if(p) {
        let index = params.findIndex((k) => k.key == p);
        if(index == -1) {
          params.unshift({key: p, value: currentParams[p]});
        }
      }
    });

    params.forEach((p) => {
      url += `${symbol}${p.key}=${p.value}`;
      symbol = '&';
    });

    return url;
  }

  getDate(moment, i18n, inputDate, format) {
    const date = moment(inputDate);
    const strDate = moment(inputDate).format(format);
    const today = moment().endOf('day');
    const tomorrow = moment().add(1, 'day').endOf('day');
    if (date < today) return i18n.t('common.today');
    if (date < tomorrow) return i18n.t('common.tomorrow');
    return strDate;
  }

  getSchedule(moment, i18n, startDate, endDate = null) {
    let strStartDate = moment(startDate).format('ha');
    let strEndDate = endDate ? `${i18n.t('common.to')} ${moment(endDate).format('ha')}` : '';
    return `${i18n.t('common.from')} ${strStartDate} ${strEndDate}`;
  }

  getUrlParams(url) {
    let params = {};
    let parser = document.createElement('a');
    parser.href = url;
    let query = parser.search.substring(1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      params[pair[0]] = decodeURIComponent(pair[1]);
    }
    return params;
  }

  getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  setCookie(cname, cvalue) {
    document.cookie = `${cname}=${cvalue};expires=Session;`;
  }

  htmlDecode(input) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = input;
    return textArea.value;
  }

  isObject(value) {
    return typeof value == KEYS.OBJECT_TYPES.OBJECT;
  }

  scrollTo(containerId, positionY) {
    if(document.getElementById(containerId) && positionY) {
      document.getElementById(containerId).scrollTop = positionY;
    }
  }

  camelCaseToString(text) {
    let result = text.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

   getChapterFromEbup(url){
    // let book = ePub(url);
    // return book.loaded.navigation;
    return url;
  }

  orderByNumber(arr) {
    arr.sort(function(a, b) {
      return a - b;
    });
    return arr;
  }

  getStore(storeName, actions, mutations) : { NAME, MUTATIONS, ACTIONS } {
    return {
      NAME: storeName,
      MUTATIONS: this.getJsonStore(storeName, mutations),
      ACTIONS: this.getJsonStore(storeName, actions)
    };
  }

  getJsonStore(storeName, elements) {
    let json = {};
    Object.keys(elements).forEach((a) => {
      json[a] = `${storeName}/${elements[a]}`;
    });
    
    return json;
  }

  reCastObjects<T, Q>(
    listToRecast: T[],
    toOrigin: new () => T,
    toConvert: new (data: T) => Q): Q[] {
      return listToRecast.map(item => {
        let toItem = new toOrigin();
        Object.assign(toItem, item);
        return new toConvert(toItem);
      });
  }

  exitSpecialChars(text){
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.documentElement.textContent;
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  stringParamsUrl(params:Dictionary<string>):string{
    var URLParams = '';
    if(params){
        var char = '?';
        Object.entries(params).forEach(([key,value]:any) => {
        URLParams += char;
        URLParams += key.toString() + '=' + value.toString();
        char = '&';
        });
    }
    return URLParams;
  }

  getIsMobileDevice() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\/-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\/-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\/-(n|u)|c55\/|capi|ccwa|cdm\/-|cell|chtm|cldc|cmd\/-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\/-s|devi|dica|dmob|do(c|p)o|ds(12|\/-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\/-|_)|g1 u|g560|gene|gf\/-5|g\/-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\/-(m|p|t)|hei\/-|hi(pt|ta)|hp( i|ip)|hs\/-c|ht(c(\/-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\/-(20|go|ma)|i230|iac( |\/-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\/-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\/-[a-w])|libw|lynx|m1\/-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\/-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\/-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\/-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\/-([1-8]|c))|phil|pire|pl(ay|uc)|pn\/-2|po(ck|rt|se)|prox|psio|pt\/-g|qa\/-a|qc(07|12|21|32|60|\/-[2-7]|i\/-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\/-|oo|p\/-)|sdk\/|se(c(\/-|0|1)|47|mc|nd|ri)|sgh\/-|shar|sie(\/-|m)|sk\/-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\/-|v\/-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\/-|tdg\/-|tel(i|m)|tim\/-|t\/-mo|to(pl|sh)|ts(70|m\/-|m3|m5)|tx\/-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\/-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\/-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\/-|your|zeto|zte\/-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
  }

  async sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  hasNumber(n: any) {
    return n !== null && n !== undefined ? !isNaN(Number(n)) : false;
  }

  caretRangeFromPoint(x: number, y: number): Range {
    const doc: any = document;
    let range: Range = null;

    if (doc.caretPositionFromPoint) {
      const caretPosition = doc.caretPositionFromPoint(x, y);
      range = doc.createRange();
      range.setStart(caretPosition.offsetNode, caretPosition.offset);
      range.setEnd(caretPosition.offsetNode, caretPosition.offset);

    } else if (doc.caretRangeFromPoint) {
      range = doc.caretRangeFromPoint(x, y);
    }

    return range;
  }
}

export default new ToolService();

